function loadCustomerAddresses() {
    var id = $('#customer_id').val();
    $('#customer-addresses').html('').load('/admin/customers/' + $('#customer_id') + '/addresses'.val());
}


$(document).ready(function () {

    $('#customerTabs > li > a').click(function (e) {
        e.preventDefault();
        // loadNotes('customer');
        var name = $(this).attr('href');
        loadNotes();
        $(this).tab('show');
    });
});

